import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const { ui } = constants.colors;
const { fontFamily, fontSize } = typographyStyles;

export const tabListStyle: CSSObject = {
  padding: "1em 1em 0",
  overflowY: "hidden",
  overflowX: "auto",
  height: "fit-content",

  "&&&": { gap: "8px" },

  "&&&& li": {
    borderRadius: "8px",
  },

  "&&& button": {
    borderBottomWidth: "4px",
    borderColor: "transparent",

    "&[aria-selected='true']": {
      borderColor: ui.core[700],
    },

    "& > div": {
      flexDirection: "row-reverse",
      gap: "8px",
    },
  },
};

export const newTagCss: CSSObject = {
  ...fontFamily.circular,
  ...fontSize.textXS,
  borderRadius: "0.75rem",
  color: ui.neutral[25],
  background: ui.core[500],

  "&&&&&": { padding: "4px 8px" },
};
